import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import type { AdNetworkConnectionZeitAccountStatuses } from '../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetAdAccountsStatusPayload } from '../AdPartner.types';

const GetAdAccountsStatus = new ReduxAsyncAction<'GET_AD_ACCOUNTS_STATUS', String, GetAdAccountsStatusPayload>(
  'GET_AD_ACCOUNTS_STATUS'
);
GetAdAccountsStatus.registerRequest((machineName) => {
  return dash_api.get(`/v1/ad-network/ad-accounts-status?machine_name=${machineName || ''}`).then(({ data }) => {
    return data;
  });
});
export const GET_AD_ACCOUNTS_STATUS = GetAdAccountsStatus.actionNamespaceConstants;
export const getAdAccountsStatus = GetAdAccountsStatus.request;

export type GetAdAccountsStatusAction = Action<typeof GET_AD_ACCOUNTS_STATUS.response> & {
  data: AdNetworkConnectionZeitAccountStatuses;
};

export type GetAdAccountsStatusErrorAction = Action<typeof GET_AD_ACCOUNTS_STATUS.error> & {
  data: Record<string, any>;
};
